/* eslint react/jsx-key: off */
import React from 'react';
import {
    Create,
    FormTab,
    SaveButton,
    TabbedForm,
    NumberInput,
    DateInput,
    SelectInput,
    ReferenceInput,
    Toolbar,
    required,
} from 'react-admin';

const PackageStockInEditToolbar = ({ permissions, ...props }) => (
    <Toolbar {...props}>
        <SaveButton
            label='resources.actions.save_and_show'
            redirect="show"
            submitOnEnter={true}
        />
        {permissions === 'admin' && (
            <SaveButton
                label='resources.actions.save_and_next'
                redirect={false}
                submitOnEnter={false}
                variant="flat"
            />
        )}
    </Toolbar>
);


const PackageStockInCreate = function({ permissions, ...props }) {
    const urlParams = new URLSearchParams(props.location.search);

    return (
    <Create {...props}>
        <TabbedForm toolbar={<PackageStockInEditToolbar permissions={permissions} />}>
            <FormTab label="resources.packagestockins.form.summary" path="">
                <ReferenceInput source="purchaseId" reference="purchases" perPage={100} validate={required()} label="resources.packagestockins.fields.purchase" defaultValue={parseInt(urlParams.get('purchase_id'))}>
                    <SelectInput optionText="name" />
                </ReferenceInput>
                <ReferenceInput source="packageId" reference="packages" perPage={100} validate={required()} label="resources.packagestockins.fields.package" defaultValue={parseInt(urlParams.get('package_id'))}>
                    <SelectInput optionText="name" />
                </ReferenceInput>
                <NumberInput
                    source="qty"
                    validate={required()}
                />
                <DateInput
                    source="stockInDate"
                    label="resources.stockins.fields.stockInDate"
                    defaultValue={new Date()}
                />
                <SelectInput source="warehouse" choices={[
                    { id: 'china', name: 'China' },
                    { id: 'stl', name: 'STL' },
                ]} validate={required()} defaultValue="china" />
                <ReferenceInput source="appUserId" reference="appusers" validate={required()} label="resources.packagestockins.fields.user" defaultValue={JSON.parse(localStorage.getItem('lbtoken')).value.userId}>
                    <SelectInput optionText="username" />
                </ReferenceInput>
            </FormTab>
        </TabbedForm>
    </Create>
    )
};

export default PackageStockInCreate;
